"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _icon = require("../icon");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Button = exports.Button = function Button(_ref) {
  var dataTestId = _ref.dataTestId,
    disabled = _ref.disabled,
    badge = _ref.badge,
    iconClassName = _ref.iconClassName,
    secondary = _ref.secondary,
    minimal = _ref.minimal,
    _ref$iconOutlined = _ref.iconOutlined,
    iconOutlined = _ref$iconOutlined === void 0 ? false : _ref$iconOutlined,
    iconGlyph = _ref.iconGlyph,
    onClick = _ref.onClick,
    label = _ref.label,
    className = _ref.className,
    children = _ref.children;
  var buttonClasses = (0, _classnames["default"])("flex whitespace-nowrap relative items-center cursor-pointer rounded-lg px-large py-regular min-h-10 transition-colors", {
    "bg-default enabled:hover:bg-slate-50 border border-primary text-primary dark:bg-slate dark:border-dark-primary dark:enabled:hover:bg-black dark:enabled:text-white disabled:text-slate-400 disabled:border-disabled dark:disabled:border-slate-800": secondary,
    "bg-blue font-medium enabled:hover:bg-blue-800 shadow-[0px_1px_2px_0px_rgba(0,0,0,0.08),_0px_-1px_1px_0px_rgba(0,0,0,0.16)_inset] min-h-[42px] text-white disabled:bg-disabled": !secondary,
    "pl-medium": iconGlyph,
    "text-primary border-0": minimal,
    "shadow-none hover:bg-inherit hover:cursor-not-allowed": disabled
  }, className);
  var iconClasses = (0, _classnames["default"])({
    "pr-regular": (label === null || label === void 0 ? void 0 : label.length) && !children,
    "text-primary dark:text-white": secondary || minimal,
    "text-white": !secondary,
    hidden: !iconGlyph,
    "opacity-25": disabled
  }, iconClassName);
  return /*#__PURE__*/_react["default"].createElement("button", {
    "data-testId": dataTestId,
    disabled: disabled,
    className: buttonClasses,
    onClick: onClick
  }, Boolean(badge) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "\n          rounded-full \n          bg-red border-[1px] border-white \n          h-[12px] w-[12px]\n          absolute -top-[4px] -right-[5px] \n          text-[8px] text-white\n          "
  }, badge), iconGlyph && /*#__PURE__*/_react["default"].createElement(_icon.Icon, {
    outlined: iconOutlined,
    glyphName: iconGlyph,
    className: iconClasses
  }), label && /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-base"
  }, label), children);
};